import { Navigate } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider.js";
import { isRoleAllowed } from "./role-guard.js";
import type { UserRole } from "../types.js";
import type { ReactNode } from "react";

/**
 * Guard de rota por papel (decisão 5 do WEBUI-PLAN.md). A ocultação no menu é
 * só UX; este guard é a barreira: acesso indevido (ex.: URL direta /usuarios ou
 * /fornecedores como Operador) redireciona para `/`. O backend revalida sempre.
 */
export function RequireRole({
  role,
  children
}: {
  role: UserRole;
  children: ReactNode;
}): ReactNode {
  const { me } = useAuth();
  if (!isRoleAllowed(me?.role ?? null, role)) {
    return <Navigate to="/" replace />;
  }
  return children;
}
